import React from 'react'
import { motion } from 'framer-motion';
import home from './images/home.mp4'

const Hero = () => {
    const transition = { type: 'spring', duration: 1 }
    return (
        <>
            <div className="container-fluid mx-3">

                <div class="grid grid-cols-12  justify-between relative">

                    <div class="lg:col-span-5 md:col-span-5 col-span-12 mt-[3rem] md:mt-[1.5rem] lg:mt-[14rem]">
                        <motion.div
                            initial={{ left: '-300px' }}
                            whileInView={{ left: '4px' }}
                            transition={{ ...transition, type: 'tween' }}
                            className="  text-[#004A8B] lg:text-6xl relative tracking-wide    md:text-[2rem] text-3xl">
                            <h1 className='head1'>Genuine leaders in specialist property</h1>
                        </motion.div>
                        <div className="lg:text-[1.3rem] lg:w-[70%] w-full text-[1rem] py-4">As leaders in specialist real estate,
                            we provide industry best transactional,
                            valuation and advisory services.
                        </div>
                    </div>

                    <div class="lg:col-span-7 md:col-span-7 col-span-12 aspect-video ">

                        <div className="banner overflow-hidden  lg:w-[916px] lg:h-[920px] absolute lg:left-[610px] ">
                                <motion.div
                                    initial={{ right: '40rem' }}
                                    whileInView={{ right: '7rem' }}
                                    transition={{ ...transition, type: 'tween' }} className="w-[250px] right-0 top-[30%] md:block hidden  h-[250px]  rounded-full absolute   bg-[#004a8b]">

                                </motion.div>
                            <video src={home} alt="videohome" autoPlay loop muted className=' w-full' ></video>
                        </div>

                    </div>
                </div>

            </div>

        </>
    )
}

export default Hero